/**
 * The ngx-mask output for the editable currency inputs (B32). Those inputs set [leadZero] so
 * the mask shows two decimals ("5" reads "5.00" once you leave the field), and with it on the
 * mask emits the bound value as a fixed-point string ("5.00"). This turns that back into the
 * number the forms bound before, so nothing reading them changes. A blank field stays blank,
 * so required validation still sees it as empty, and so does a partial entry that is not a
 * number yet ("-", "."): NaN would count as filled in and pass required, min and max.
 */
export function currencyMaskOutput(value: string | number | null | undefined) {
    if (value === '' || value === null || value === undefined) {
        return value;
    }

    const amount = Number(value);

    return Number.isFinite(amount) ? amount : '';
}
